import { CLEAR_ALL_FIELDS, CLEAR_SECTION_FIELDS, SET_SECTION_FIELDS } from "../constant";

const initialState = {
  surveyFieldsData: {},
}

const surveyFieldDataReducer = (state = initialState, action) => {
  switch (action.type) {

    //Get survey report
    case CLEAR_SECTION_FIELDS:
      let tmpCleredFields = { ...state.surveyFieldsData }
      tmpCleredFields[action.payload] = {}
      return {
        ...state,
        surveyFieldsData: { ...tmpCleredFields }
      }

    case SET_SECTION_FIELDS:
      let tmpNewSectionFields = { ...state.surveyFieldsData }
      tmpNewSectionFields[action.payload.section] = action.payload.data
      return {
        ...state,
        surveyFieldsData: { ...tmpNewSectionFields }
      }

    case CLEAR_ALL_FIELDS:
      return {
        ...state,
        surveyFieldsData: {},
      }

    //Default
    default:
      return state;
  }
}

export default surveyFieldDataReducer